'use client';

import { Box, Container, Typography } from '@mui/material';

import { Product } from '../../../services';

interface ProductDetailSectionProps {
  product: Product;
}

const ProductDetailSection = ({ product }: ProductDetailSectionProps) => {
  return (
    <Box sx={{ py: 6, backgroundColor: '#f8f9fa' }}>
      <Container maxWidth='lg'>
        <Typography variant='h4'>Product Detail</Typography>
        <Typography variant='body1'>{product.name}</Typography>
      </Container>
    </Box>
  );
};

export default ProductDetailSection;
